<template>
    <AppLayout class="custom-formulation">
        <BaxHeaderBannerSimple :user="this.$store.state.auth.user" :containerClass="'full-page'">
        Your Custom Formulations
        </BaxHeaderBannerSimple>
        <main class="formulation-list">
            <div class="bax-section">
                <div class="container full-page" v-if="asyncDataLoaded === true">
                    <div class="form-section">
                        <div class="form-container">
                            <div class="panel">
                                <div class="intro d-flex justify-content-between">
                                    <h3>Custom Formulations</h3>
                                    <div class="ml-auto">
                                        <router-link :to="{ name: 'TPNCustomFormulationCreate' }" class="bax-btn bax-btn-bordered-blue-brand">Start new formulation</router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="panel" v-if="listComplete.length">
                                <div class="filter-header d-flex justify-content-between">
                                   <p>Filters</p>
                                   <button @click.prevent="onFiltersReset">Reset Filters</button>
                                </div>
                                <div class="section-filters">
                                    <div class="formulation-form-row align-items-end">
                                        <div class="col-2">
                                            <label>Contains text:</label>
                                            <input type="text" class="form-control" v-model="filters.text">
                                        </div>
                                        <div class="col-2">
                                            <label>From:</label>
                                            <DateEntry class="form-control" ref="datepickerFrom" v-model="filters.date_from"></DateEntry>
                                        </div>
                                        <div class="col-2">
                                            <label>To:</label>
                                            <DateEntry class="form-control" ref="datepickerTo" v-model="filters.date_to"></DateEntry>
                                        </div>
                                        <div class="col-2">
                                            <label>Formulated for:</label>
                                            <select v-model="filters.type" class="form-control">
                                                <option value="">All</option>
                                                <option value="general">General Stock</option>
                                                <option value="in_patient">In-Patient</option>
                                                <option value="home_patient">Home Patient</option>
                                            </select>
                                        </div>
                                        <div class="col-2">
                                            <label>Status:</label>
                                            <select v-model="filters.status" class="form-control">
                                                <option value="">All</option>
                                                <option value="draft">Draft</option>
                                                <option value="submitted">Submitted for review</option>
                                                <!-- <option value="ready">Ready to order</option> -->
                                            </select>
                                        </div>
                                        <div class="col-2">
                                            <button type="button" class="bax-btn bax-btn-bordered-blue-brand" @click.prevent="onListRefresh">Apply</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-list">
                                    <div class="formulation-table">
                                        <p class="counters">Showing {{listPaginated.length}} of {{listFiltered.length}} formulations</p>
                                        <table>
                                            <tr>
                                                <th>Description</th>
                                                <th>Patient</th>
                                                <th>Stability</th>
                                                <th>Status</th>
                                                <!-- <th>Product code</th> -->
                                                <th>Latest activity</th>
                                            </tr>
                                            <template v-for="(item, index) in listPaginated">
                                                <tr :key="'el_' + index" @click.prevent="onClickrow(item.id)">
                                                    <td>{{ item.description }}</td>
                                                    <td>{{ item.patient }}</td>
                                                    <td class="stability" :class="item.stability">{{ item.stability }}</td>
                                                    <td class="status">{{ item.status }}</td>
                                                    <!-- <td>{{ item.productCode }}</td> -->
                                                    <td>
                                                        {{item.status === 'submitted' ? 'Submitted by:' : 'Last modified by:'}}
                                                        <br>
                                                        {{item.lastActivityUser}}, {{item.lastActivityDate}} {{item.lastActivityTime}}
                                                    </td>
                                                </tr>
                                            </template>
                                        </table>
                                    </div>
                                </div>
                                <div v-if="getTotPages > 1" class="section-pagination d-flex justify-content-center">
                                    <button @click.prevent="onPaginationClick('prev')" :class="{ 'disabled': activePage <= 1 }">&lt;&lt; Prev</button>
                                    <template v-for="pageNum in getTotPages">
                                        <button @click.prevent="onPaginationClick(pageNum)" :key="pageNum" :class="{ 'disabled': pageNum === activePage }">{{pageNum}}</button>
                                    </template>
                                    <button @click.prevent="onPaginationClick('next')" :class="{ 'disabled': activePage >= getTotPages }">Next &gt;&gt;</button>
                                </div>
                            </div>
                            <div class="panel" v-else>
                                <p>There are no saved formulations</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </AppLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import AppLayout from '@/components/layout/AppLayout.vue';
import BaxHeaderBannerSimple from '@/components/layout/BaxHeaderBannerSimple.vue';
import { scrollPageToTop } from '@/core/helpers';
import CustomFormulationService from '@/core/api/tpn/customFormulation.service';
import DateEntry from '@/components/ui/DateEntry.vue';
import moment from 'moment';

export default {
    name: 'CustomFormulation',
    components: {
        AppLayout,
        BaxHeaderBannerSimple,
        DateEntry,
    },
    data() {
        return {
            filters: {
                text: '',
                date_from: '',
                date_to: '',
                type: '',
                status: '',
            },
            listComplete: [],
            listFiltered: [],
            listPaginated: [],
            paginationItems: 10,
            activePage: 1,
            asyncDataLoaded: false,
        };
    },
    computed: {
        ...mapGetters(['authenticatedUser']),
        getTotPages() {
            return Math.ceil(this.listFiltered.length / this.paginationItems);
        },
    },
    created() {
        scrollPageToTop();
        const { q, status } = this.$route.query;

        CustomFormulationService.getCustomFormulationList()
        .then((res) => {
            const { data } = res;
            this.asyncDataLoaded = true;
            this.listComplete = data.list;
            this.listFiltered = data.list;
            this.getListPaginated();
            if (q !== '' && typeof q !== 'undefined') {
                this.filters.text = q;
            }
            if (status !== '' && typeof status !== 'undefined') {
                this.filters.status = status;
            }
            this.onListRefresh();
        });
    },
    methods: {
        onClickrow(itemId) {
            this.$router.push({ name: 'TPNCustomFormulationCreate', params: { code: itemId } });
        },
        onListRefresh() {
            this.listFiltered = this.listComplete.filter((item) => {
                let valid = true;
                // text filter
                if (this.filters.text) {
                    const searchText = this.filters.text.toLowerCase();
                    valid = false;
                    if (item.description.toLowerCase().includes(searchText)) {
                        valid = true;
                    }
                    if (item.patient.toLowerCase().includes(searchText)) {
                        valid = true;
                    }
                    if (item.productCode.toLowerCase().includes(searchText)) {
                        valid = true;
                    }
                }
                // date from filter
                if (this.filters.date_from) {
                    valid = false;
                    const dateFilter = moment(this.filters.date_from, 'DD/MM/YYYY');
                    const dateItem = moment(item.lastActivityDate, 'DD/MM/YYYY');

                    if (dateItem.diff(dateFilter, 'days') >= 0) {
                        valid = true;
                    }
                }
                // date to filter
                if (this.filters.date_to) {
                    valid = false;
                    const dateFilter = moment(this.filters.date_to, 'DD/MM/YYYY');
                    const dateItem = moment(item.lastActivityDate, 'DD/MM/YYYY');

                    if (dateItem.diff(dateFilter, 'days') <= 0) {
                        valid = true;
                    }
                }
                // type filter
                if (this.filters.type) {
                    valid = false;
                    if (item.type === this.filters.type) {
                        valid = true;
                    }
                }
                // status filter
                if (this.filters.status) {
                    valid = false;
                    if (item.status === this.filters.status) {
                        valid = true;
                    }
                }
                return valid;
            });
            this.getListPaginated();
        },
        onFiltersReset() {
            this.filters = {
                text: '',
                date_from: '',
                date_to: '',
                type: '',
                status: '',
            };
            // this.$refs.datepickerFrom.clearDate();
            // this.$refs.datepickerTo.clearDate();
            this.listFiltered = this.listComplete;
        },
        getListPaginated() {
            const start = (this.activePage - 1) * this.paginationItems;
            this.listPaginated = this.listFiltered.slice(start, start + this.paginationItems);
        },
        onPaginationClick(type) {
            switch (type) {
                case 'prev':
                    this.activePage -= 1;
                    break;
                case 'next':
                    this.activePage += 1;
                    break;
                default:
                    this.activePage = type;
            }

            if (this.activePage <= 0) {
                this.activePage = 1;
            }
            if (this.activePage >= this.getTotPages) {
                this.activePage = this.getTotPages;
            }
            this.getListPaginated();
        },
    },
};
</script>
